import { ChevronDownIcon } from "lucide-react";
import { Button, DefaultPopover, List, ListItem, Select, ToggleOptionGroup, ToggleOptionGroupItem } from "twyne-new.ui";

import { useCraftProperty } from "../../core/hooks";

import { useCraftOptions, useGlobalStateContext } from ".";

export function StateToolbarButton() {
  const { states, hasStates } = useGlobalStateContext()

  if (!hasStates) return null

  return <DefaultPopover
    contentProps={{ className: 'w-[400px]' }}
    trigger={<Button className='h-8' size='md' variant='outline' color='warning'>
      <ChevronDownIcon size={16} />
      States
    </Button>
    }>
    <List>
      {states.map(({ Component, label, prop }, idx) => <ListItem key={idx} className="grid grid-cols-3 gap-1" value={<>
        <p className="justify-self-start col-span-1 flex gap-1 items-center self-center">
          {label}
        </p>
        <div className="col-span-2">
          <Component name={prop} />
        </div>
      </>} />)}
    </List>
  </DefaultPopover>
}

export function StateToggle({ value, onChange, options }) {
  return <ToggleOptionGroup type='single' size='lg' value={value} onValueChange={value => value && onChange(value)}>
    {options.map(({ label, value }) => <ToggleOptionGroupItem key={value} value={value}>
      {label}
    </ToggleOptionGroupItem>)}
  </ToggleOptionGroup>
}

export function StateToggleComponent({ name }) {
  const { setValue, value } = useCraftProperty(`properties.${name}`)
  const { options } = useCraftOptions()

  const Component = options.length > 3 ? Select : StateToggle
  const handleChange = value => setValue(options.length > 3 ? value.value : value)

  return <Component value={value} onChange={handleChange} options={options} />
}
